import Alpine from "../alpine.js"
import Chart from "chart.js/auto"
import 'chartjs-adapter-date-fns'

Alpine.data("lineChart", ({ labels, datasets, minX, maxX, minY, maxY }) => ({
  minX,
  maxX,
  minY,
  maxY,
  labels,
  datasets,
  init() {
    this.$nextTick(() => {
      let chart = new Chart(this.$refs.canvas.getContext("2d"), {
        type: "line",
        data: {
          labels: this.labels,
          datasets: this.datasets,
        },
        options: {
          responsive: true,
          interaction: { intersect: false },
          scales: {
            y: {
              beginAtZero: false,
              position: "right",
              min: this.minY,
              max: this.maxY
            },
            x: {
              type: "time",
              time: { minUnit: "day" },
              min: this.minX,
              max: this.maxX
            }
          },
          plugins: {
            legend: { display: false },
            tooltip: {
              displayColors: false
            }
          }
        }
      })
      this.$watch("datasets", () => {
        chart.data.labels = this.labels
        chart.data.datasets = this.datasets
        chart.update()
      })
    })
  }
}))
